(() => {

    class DeviceBookingSummary {

        constructor() {

            this.summaryFields = document.querySelectorAll('[data-summary]');

            if (!this.summaryFields.length) return;

            this.init();

        }

        init() {

            this.bindInputs();

            this.update();

        }

        bindInputs() {

            document.addEventListener('input', () => {

                this.update();

            });

            document.addEventListener('change', () => {

                this.update();

            });

            document.addEventListener('click', () => {

                requestAnimationFrame(() => {

                    this.update();

                });

            });

        }

        update() {

            /*
            |--------------------------------------------------------------------------
            | Elevator Charge
            |--------------------------------------------------------------------------
            */

            const elevatorRow = document.querySelector(
                "[data-summary-elevator]"
            );

            const elevatorDivider = document.querySelector(
                "[data-summary-elevator-divider]"
            );

            const elevatorPrice = document.querySelector(
                "[data-summary-elevator-price]"
            );

            if (

                elevatorRow &&
                elevatorDivider &&
                elevatorPrice

            ) {

                if (

                    window.deviceBooking &&
                    window.deviceBooking.elevator.required

                ) {

                    elevatorRow.hidden = false;
                    elevatorDivider.hidden = false;

                    elevatorPrice.textContent =
                        window.deviceBooking.elevator.displayPrice;

                }

                else {

                    elevatorRow.hidden = true;
                    elevatorDivider.hidden = true;

                }

            }

            this.summaryFields.forEach(summary => {

            const key = summary.dataset.summary;

                /*
                |--------------------------------------------------------------------------
                | Total
                |--------------------------------------------------------------------------
                */

                if (key === "total") {

                    let total = Number(
                        document.getElementById(
                            "device-booking-price"
                        )?.value || 0
                    );

                /*
                |--------------------------------------------------------------------------
                | Elevator Charge
                |--------------------------------------------------------------------------
                */

                if (

                    window.deviceBooking &&
                    window.deviceBooking.elevator &&
                    window.deviceBooking.elevator.required

                ) {

                    total += Number(
                        window.deviceBooking.elevator.rawPrice || 0
                    );

                }

                summary.textContent =
                    "$" + Math.round(total / 100);

                return;

            }

                /*
                |--------------------------------------------------------------------------
                | Normal Summary Fields
                |--------------------------------------------------------------------------
                */

                const source = document.querySelector(
                    `[data-summary-source="${key}"]`
                );

                if (!source) return;

                let value = "";

                if (source.type === "radio") {

                    const checked = document.querySelector(
                        `[data-summary-source="${key}"]:checked`
                    );

                    value = checked ? checked.value : "";

                }

                else if (source.type === "checkbox") {

                    value =
                        source.checked
                            ? "Yes"
                            : "No";

                }

                else if (source.tagName === "SELECT") {

                    value =
                        source.options[
                            source.selectedIndex
                        ]?.text || "";

                }

                else {

                    value = source.value;

                }

                const summaryRow =

                    summary.closest(".device-summary__item") ||

                    summary.parentElement;

                if (

                    !value ||

                    value.trim() === "" ||

                    value === "0"

                ) {

                    if (summaryRow) {

                        summaryRow.style.display = "none";

                    }

                    return;

                }

                if (summaryRow) {

                    summaryRow.style.display = "";

                }

                summary.textContent = value;

            });

        }

       } 

    document.addEventListener('DOMContentLoaded', () => {

        new DeviceBookingSummary();

    });

})();